<template>
  <div class="fu">
    login
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
.fu {
  background-color: rgb(70, 157, 168);
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue